import { SelectBox } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import type { AvailableSortTypesType } from '../../../models';

const selectBoxStyles = css`
  flex: 0;
  padding: 16px 16px 0;
`;

type Option = {
  label: string;
  value: string;
};

const getOptions = (sortTypes: AvailableSortTypesType) =>
  sortTypes
    .filter((item) => item !== null)
    .map((sortType) => ({
      value: sortType.code,
      label: sortType.name,
    }));

interface SortTypesProps {
  availableSortTypes: AvailableSortTypesType;
  onSort: (value: string) => void;
  selectedSortType: string;
}

const SortTypes = ({ availableSortTypes = [], onSort, selectedSortType }: SortTypesProps) => {
  const { t } = useTranslation();
  const options = getOptions(availableSortTypes);
  const selectedValue = options.find((option) => option.value === selectedSortType) ?? null;

  const handleSelect = (option: Option) => {
    onSort(option.value);
  };

  return (
    <SelectBox
      className={selectBoxStyles}
      data-testid="resultPage-debugFilters-sortTrips-dropdown"
      label={t('Result.SortTripsBy.Label')}
      name="debugFilters-sortTrips"
      onChange={handleSelect}
      options={options}
      value={selectedValue}
    />
  );
};

export default SortTypes;
